import React from 'react'
import styled from 'styled-components';
import Icon from '../Icon';
import MobileFooterMenuIconWrapper from './MobileFooterMenuIconWrapper';
import IconText from './IconText';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers';
import LoginModalTriggerMobile from './LoginModalTriggerMobile';

const StyledLoginIcon = styled(Icon)`
  cursor: pointer;
`;

const LoginIconLinkMobile = () => {

    const myPage = useSelector((state: RootState) => state.pages.myPage);
    const userInfo = useSelector((state: RootState) => state.userInfo);
    const isAuthenticated = userInfo.current;

    return (
        <>
            {isAuthenticated ? (
                <a href={myPage.href} title={myPage.text} aria-label={myPage.text} className="hover:opacity-80">
                    <MobileFooterMenuIconWrapper className="flex flex-col items-center gap-2">
                        <StyledLoginIcon name='user' className="login__btn icon--larger" />
                        <IconText
                            text={userInfo.current?.firstName ? userInfo.current?.firstName : undefined}
                            translationKey={userInfo.current?.firstName ? undefined : 'general.profile'} >
                        </IconText>
                    </MobileFooterMenuIconWrapper>
                </a>
            ) : (
                <LoginModalTriggerMobile />
            )}
        </>
    )
}

export default LoginIconLinkMobile